import React, { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";

import MalePatientAvatar from "../../assets/images/patient-avatar.png";
import FemalePatientAvatar from "../../assets/images/female-avatar.jpg";

import { ROUTES } from "../../constants"

function SearchResultsSection(props) {
    const { searchResults } = props;

    const navigate = useNavigate()

    const [currentIndex, setCurrentIndex] = useState(0);

    const handleNext = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === searchResults.length - 1 ? prevIndex : prevIndex + 1
        );
    };

    const handlePrev = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? 0 : prevIndex - 1
        );
    };

    const patientResultsJSX = useMemo(() => {
        return searchResults?.map((patient, index) => {
            return (
                <div
                    key={index}
                    className="absolute w-40 h-full flex-shrink-0 flex flex-col gap-6"
                    style={{
                        transform: `translateX(${(index - currentIndex) * 110}%)`,
                        transition: "transform 0.5s ease",
                    }}
                >
                    <img
                        alt="client avatar"
                        src={patient?.gender === "M" ? MalePatientAvatar : FemalePatientAvatar}
                        className="w-40 h-auto aspect-square"
                    />
                    <h6 className="text-center font-semibold capitalize text-xl text-text-1 flex-shrink-0">
                        {patient?.firstName} {patient?.lastName}
                    </h6>
                </div>
            );
        });
    }, [searchResults, currentIndex]);

    if (!searchResults?.length) {
        return (
            <div className="flex-grow flex items-center">
                <h2 className="text-center text-text-3 font-medium text-2xl">No clients found</h2>
            </div>
        )
    }

    return (
        <section className="flex flex-col items-center gap-5 w-full">
            {!searchResults?.length && (
                <p className="text-center text-text-3">No clients found.</p>
            )}
            <div className="relative flex justify-center overflow-visible">
                <div className="relative w-40 h-80 overflow-hidden">
                    <div className="flex">
                        {patientResultsJSX}
                    </div>
                </div>
                <svg className="absolute -left-16 top-1/4 -translate-y-1/2 h-6 w-6 cursor-pointer rotate-180" onClick={handlePrev} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                    <path d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z" fill="#B7E5E4" />
                </svg>
                <svg className="absolute -right-16 top-1/4 -translate-y-1/2 h-6 w-6 cursor-pointer" onClick={handleNext} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                    <path d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z" fill="#B7E5E4" />
                </svg>
            </div>
            <button
                className="mt-5 w-[265px] py-3 bg-[#f4831f] font-semibold rounded-[5px] text-white cursor-pointer capitalize focus:outline-none"
                onClick={() => navigate(ROUTES.IMAGE_CAPTURE.DYNAMIC(searchResults[currentIndex]?.id))}
            >
                Select client
            </button>

        </section>
    );
}

export default SearchResultsSection;
